import { makeCRUDSlice } from 'redux/crudCreator';
import {
  MODEL_NAME,
  contactsActions,
  getSummaryDetailContact,
} from './actions';

const getSummaryDetailContactPending = (state) => {
  state.summaryDetail = {};
};

const getSummaryDetailContactSuccess = (state, { payload }) => {
  state.summaryDetail = payload;
};

const slice = makeCRUDSlice(MODEL_NAME, contactsActions, {
  [getSummaryDetailContact.pending.toString()]: getSummaryDetailContactPending,
  [getSummaryDetailContact.fulfilled.toString()]:
    getSummaryDetailContactSuccess,
});

export default slice.reducer;
